import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import PasswordInput from '../../components/PasswordInput';
import Button from '../../../incase-domain/components/button/Button';
import {useResetPassword} from './queries';

function ResetPasswordPage(): JSX.Element {
    const {t} = useTranslation();
    const {code} = useParams();

    const {mutate: resetPassword, isLoading, data: response} = useResetPassword();

    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');

    const isDisabled = !password.length || !repeatPassword.length || isLoading;

    return (
        <div className="p-resetPassword">
            <main>
                <form
                    className="c-passwordReset__form u-flex u-flex-col u-gap-4"
                    onSubmit={(e: React.FormEvent) => {
                        e.preventDefault();
                        if (isDisabled) return;
                        code && resetPassword({password, repeatPassword, code});
                    }}
                >
                    <PasswordInput
                        onChange={(password) => setPassword(password)}
                        value={password}
                        placeholder={t('resetPasswordPage.enterYourNewPassword')}
                        errors={response?.errors}
                        name="password"
                    />
                    <PasswordInput
                        onChange={(repeatPassword) => setRepeatPassword(repeatPassword)}
                        value={repeatPassword}
                        placeholder={t('resetPasswordPage.confirmYourNewPassword')}
                        errors={response?.errors}
                        name="repeatPassword"
                    />
                    <Button fullWidth className="u-mt-3" disabled={isDisabled} variant="solid" size="sm" color="secondary" type="submit">
                        {t('resetPasswordPage.submit')}
                    </Button>
                </form>
            </main>
        </div>
    );
}

export default ResetPasswordPage;
